import styled from '@emotion/styled'
import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'

import queryString from 'query-string'
import PersonliseModal from '../components/Personalisation'
import PanelRenderer from '../components/panels/panel-renderer'
import Reviews from '../components/product-page/reviews'
import GallerySectionV3 from '../components/product-page/v3/gallery-section'
import GallerySectionV2 from '../components/product-page/v2/gallery-section'

import SelctorSection from '../components/product-page/v3/selector-section'
import SEO from '../components/seo/index'
import { useShopStoreIncontext } from '../context/shopContext'
import calculateDiscount from '../helpers/calculateDiscount'
import useTracking from '../helpers/useTracking'
import useIsInView from '../hooks/useIsInView'
import useSelectedColor from '../hooks/useSelectedColor'
import '../styles/reviews.css'

const LandingContainer = styled.div`
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-around;
  @media (min-width: 763px) {
    flex-direction: row;
    /* padding-top: 64px; */
  }
`

function retryLearnQ(query, timout) {
  try {
    query()
  } catch (err) {
    if (!window.location.href.includes('uk')) {
      setTimeout(() => retryLearnQ(query, timout), timout)
    }
  }
}
function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}
function hexToRgb(hex) {
  try {
    if (!hex) return [0, 0, 0]
    const bigint = parseInt(hex.substring(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
  } catch (e) {
    return [0, 0, 0]
  }
}
function rgbToHsv(r, g, b) {
  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, v = max;

  let d = max - min;
  s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  return [h, s, v];
}
const getShopifySkuData = (products) => {
  let allData = {}
  products.Variants.map(
    (variant) => {
      const metaId = `shopify_${products?.shopifyInfo?.shopifyId?.replace('gid://shopify/Product/', '')}_${variant?.shopifyInfo?.shopifyId?.replace('gid://shopify/ProductVariant/', '')}`
      allData[variant?.shopifyInfo?.sku] = {
        id: variant?.shopifyInfo?.shopifyId,
        sku: variant?.shopifyInfo?.sku,
        image: variant?.shopifyInfo?.image,
        price: variant?.shopifyInfo?.price,
        title: variant?.shopifyInfo?.title,
        meta_id: metaId?.includes('undefined') ? undefined : metaId,
        productId: products?.shopifyInfo?.shopifyId?.replace('gid://shopify/Product/', ''),
        product_categories: products?.product_categories,
      }
      if (variant?.shopifyInfoPers) {
        allData[variant?.shopifyInfoPers?.sku] = {
          id: variant?.shopifyInfoPers?.shopifyId,
          sku: variant?.shopifyInfoPers?.sku,
          image: variant?.shopifyInfoPers?.image,
          price: variant?.shopifyInfoPers?.price,
          title: variant?.shopifyInfoPers?.title,
          productId: products?.shopifyInfo?.shopifyId?.replace('gid://shopify/Product/', ''),
          product_categories: products?.product_categories,
        }
      }
    }
  )

  return allData
}
const useShopifyData = (localeData, locale) => {
  const [skuData] = useState(getShopifySkuData(localeData))
  return {
    [locale]: {
      skuData,
      productId: localeData?.shopifyInfo?.shopifyId.replace('gid://shopify/Product/', ''),
      tolstoyId: localeData?.shopifyInfo?.storefrontId.replace('gid://shopify/Product/', ''),
      reviewData: localeData?.shopifyInfo?.reviewData
    },
  }
}
const useProduct = (strapiProduct, rawStock) => {
  let product = {
    ...strapiProduct,
    product_categories: strapiProduct.product_categories?.map((val) => val.CategoryName),
  }

  let stock = JSON.parse(rawStock.skus)

  if (!product) return {}
  const { stock: contextStock, storeLocale } = useShopStoreIncontext(
    (state) => {
      return {
        stock: state.stock,
        storeLocale: state.storeLocale,
      }
    }
  )
  if (contextStock[storeLocale] != null) {
    stock = contextStock[storeLocale]
  }
  product.Variants = product.Variants.map((variant) => ({
    ...variant,
    oosData: variant.SKU.includes('giftcard') ? {} : { ...stock[variant.SKU] },
    product_categories: strapiProduct.product_categories?.map((val) => val.CategoryName),
  }))

  // Upsell producst variants oosData
  if (strapiProduct?.Upsell?.Product?.Variants !== null && strapiProduct?.Upsell?.Product?.Variants !== undefined) {
    strapiProduct.Upsell.Product.Variants = strapiProduct.Upsell.Product.Variants.map((variant) => ({
      ...variant,
      oosData: variant.SKU.includes('giftcard') ? {} : { ...stock[variant.SKU] },
    }))
  }

  return {
    product,
    stock,
  }
}
function formatDecimal(number) {
  if (Number.isInteger(number)) {
    return number?.toFixed(0); // No decimal places
  } else {
    return number?.toFixed(1); // One decimal place
  }
}

const ArticlePage = ({ pageContext, data, location }) => {
  const { FreePersonalisation, FreeSuitcasePersonalisation, OosSignupID, PetPersonalisation, hideBundlePricing, disablePersonalisation, disableEmbroidery, discountPromoOn } = data.strapiShared
  const [labelData, setLabelData] = useState({})
  const [petLabelData, setPetLabelData] = useState({})
  const allProductData = useShopifyData(data.strapiProduct, pageContext.locale)
  const { [pageContext.locale]: { skuData, productId, tolstoyId, reviewData } } = allProductData
  const {
    storeLocale,
    currencyCode,
    setCollectionOpen,
    footerRef,
    setPauseScroll,
    addToCart,
    analytics,
  } = useShopStoreIncontext((state) => {
    return {
      storeLocale: state.storeLocale,
      currencyCode: state.currencyCode,
      setCollectionOpen: state.actions.setCollectionOpen,
      footerRef: state.footerRef,
      setPauseScroll: state.actions.setPauseScroll,
      addToCart: state.actions.addToCart,
      analytics: state.analytics
    }
  })
  const { product, stock } = useProduct(data.strapiProduct, data.stock)

  const additionalVariants = [
    {
      id: product.strapiId,
      variants: product.Variants
    }
  ]
  const additionalProducts = data?.additionalStrapiProducts?.nodes
  additionalProducts?.map(product => {
    let variants = []
    product.Variants.map(variant => {
      variants.push({
        handle: product.handle,
        product_categories: product.product_categories,
        ...variant,
        oosData: {
          ...stock[variant.SKU],
        },
      })
    })
    additionalVariants.push({
      id: product.strapiId,
      variants: variants
    })
  })
  let allVariants =
    additionalVariants
      .sort((a, b) => a.id - b.id)
      .map(val => val.variants)
      .flat()
  // .sort((a, b) => {
  //   const [hA] = rgbToHsv(...hexToRgb(a.Colour));
  //   const [hB] = rgbToHsv(...hexToRgb(b.Colour));

  //   // Adjust the hue values to start from red and wrap around the circle
  //   const adjustedHA = (hA + 0.93) % 1;
  //   const adjustedHB = (hB + 0.93) % 1;

  //   return adjustedHA - adjustedHB;
  // });

  // Condition to skip sorting for Tunks to prevent new colours being shuffled with the rest of the colours
  if (!allVariants[0].SKU.includes('TRK')) {
    allVariants
      .sort((a, b) => {
        if (a.limited === true || b.limited === true) {
          return
        }
        const [hA] = rgbToHsv(...hexToRgb(a.Colour));
        const [hB] = rgbToHsv(...hexToRgb(b.Colour));

        // Adjust the hue values to start from red and wrap around the circle
        const adjustedHA = (hA + 0.93) % 1;
        const adjustedHB = (hB + 0.93) % 1;

        return adjustedHA - adjustedHB;
      });
  }

  const colorNames = allVariants.map((variant) =>
    variant.ColourName.toLowerCase().split(' ').join('-').replace('/', 'slash')
  )
  const ossData = allVariants.map((variant) => ({
    ...skuData[variant.SKU],
    ...stock[variant.SKU],
    sku: variant.SKU,
  }))

  const [selectedColor, setSelectedColor] = useSelectedColor(
    location.search,
    0,
    colorNames,
    ossData
  )

  const [personaliseOpen, setPersonaliseOpen] = useState(Object.keys(queryString.parse(location.search)).includes('personalise'))
  useEffect(() => {
    setPauseScroll(personaliseOpen)
  }, [personaliseOpen])
  const [petPersonaliseOpen, setPetPersonalisationOpen] = useState(undefined)
  const [selectedDropdownItem, setSelectedDropdownItem] = useState(product?.Dropdown?.findIndex((val) => val.to.includes(product.handle)))
  const selectedVariant = allVariants[selectedColor]
  const personalised = isEmpty(labelData)
  const petPersonalised = isEmpty(petLabelData)
  const selectedSKU = `${selectedVariant?.SKU}${personalised && petPersonalised ? '' : '-P'}`
  const product_categories = product.product_categories
  const { Category, SubCategory, Range } = product
  const isLuggage = product.product_categories?.includes("Luggage")
  const isBag = product.product_categories?.includes("Bags", "Soft Good (Excluding Weekenders)", "Weekender")

  // Personalisation pricing calculation
  const freePers = FreePersonalisation || product.Personalisation[0]?.FreePersonalisation;
  const freeLuggagePers = FreeSuitcasePersonalisation && isLuggage;
  const addPersPrice = !freePers && !freeLuggagePers && !(personalised && petPersonalised);
  const personalisationCost = addPersPrice ? product.Personalisation[0]?.PersonalisationCost || 0 : 0;

  // Pricing calculation
  const price = (selectedVariant?.shopifyInfo?.price || 0) + personalisationCost;
  const defaultDiscount = hideBundlePricing ? 0 : (product?.Discount ? product?.Discount : 0)
  const discount = calculateDiscount(discountPromoOn, selectedVariant, defaultDiscount, price, storeLocale);

  const noSet = (product.hideSetModule === true) || !['Bag', 'Carry_On', 'Checked', 'Plus'].includes(product.BundleType)
  const images = selectedVariant.images?.map((image) => image) || []
  const thumbnails = selectedVariant.thumbnails?.map((image) => image) || []

  useEffect(() => {
    localStorage?.setItem('fbid', skuData[selectedSKU]?.meta_id)
  }, [selectedSKU, skuData])

  const [trackAddToCart, updateItem] = useTracking(
    {
      title: product.Title,
      id: skuData[selectedSKU]?.meta_id,
      imageURL: selectedVariant?.ShopTileImage?.url,
      url: `https://july.com${product.handle}?${selectedVariant.ColourName}`,
      price: price,
      sku: selectedSKU,
      currency: currencyCode,
      product_categories: product_categories,
      selectedVariant: selectedVariant,
      variant: selectedVariant.ColourName,
      Category, SubCategory, Range,
      storeLocale: storeLocale
  },
    analytics
  )

  useEffect(() => {
    // Only call updateItem if any of the values are different from current
    updateItem((prevData) => {
      const newData = {
        title: product.Title,
        id: skuData[selectedSKU]?.meta_id,
        imageURL: selectedVariant?.ShopTileImage?.url,
        url: `https://july.com${product.handle}?${selectedVariant.ColourName}`,
        price: price,
        sku: selectedSKU,
        currency: currencyCode,
        product_categories: product_categories,
        selectedVariant: selectedVariant,
        variant: selectedVariant.ColourName,
        Category, SubCategory, Range,
        storeLocale: storeLocale
      }
      
      // Only update if something changed
      if (JSON.stringify(prevData) !== JSON.stringify(newData)) {
        return newData
      }
      return prevData
    })
  }, [selectedColor])

  const handleAddToCart = async () => {
    addToCart({
      title: product.Title,
      ...(personalised ? {} : { customAttributes: labelData }),
      ...(petPersonalised ? {} : { customAttributes: petLabelData }),
      variantQuantity: 1,
      id: selectedSKU,
      product_categories: product_categories,
      Category, SubCategory, Range,
      globalProduct: { [storeLocale]: allProductData[storeLocale]['skuData'][selectedSKU] },
      currency: currencyCode,
      variant: selectedVariant.ColourName,
      ...((personalised && selectedVariant.oosData.personalisation === true && !disablePersonalisation && (['en', 'en-CA'].includes(storeLocale) ? !isBag : true)) ? {
        personalisedVariant: { [storeLocale]: allProductData[storeLocale]['skuData'][`${selectedSKU}-P`] },
      } : {}),
      personaliseInfo: selectedVariant.personaliseInfo,
    })
    trackAddToCart()
  }

  const returnAddToCart = (addToCartData) => {
    addToCart([
      {
        title: product.Title,
        ...(personalised ? {} : { customAttributes: labelData }),
        ...(petPersonalised ? {} : { customAttributes: petLabelData }),
        variantQuantity: 1,
        id: selectedSKU,
        Category, SubCategory, Range,
        product_categories: product_categories,
        globalProduct: { [storeLocale]: allProductData[storeLocale]['skuData'][selectedSKU] },
        currency: currencyCode,
        variant: selectedVariant.ColourName,
        personaliseInfo: selectedVariant.personaliseInfo,
      },
      addToCartData
    ])
  }

  const {
    inViewRef,
    isInView
  } = useIsInView(footerRef)

  const GallerySection = product["GalleryType"] ===  "Scroll" ? GallerySectionV3 : GallerySectionV2

  const personaliseData = selectedVariant?.personaliseInfo ? JSON.parse(selectedVariant.personaliseInfo) : null

  return (
    <>
      <SEO
        title={product.seo.metaTitle}
        description={product.seo.metaDescription}
        locale={pageContext.locale}
        cannonical_url={`${product.handle}`}
        keywords={product.seo?.keywords}
        og_image={product.seo?.metaImage?.file?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
        noCrawl={product.seo?.doNotIndex}

        productData={{
          name: product.Title,
          imageSrc: images[0]?.file?.publicURL,
          description: product.seo.metaDescription,
          price: price,
          sku: selectedSKU,
          handle: product.seo.canonicalURL,
        }}
        reviewData={{
          value: `${formatDecimal(reviewData?.aggregateRating)}`,
          count: `${reviewData?.reviewCount}`,
        }}
      />
      <div
        style={{
          display: personaliseOpen ? 'block' : 'none',
          height: '100vh',
        }}
      >
        {personaliseOpen && personaliseData && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              zIndex: 9999999999,
            }}
          >
            <PersonliseModal
              handleSave={(data) => {
                setPersonaliseOpen(false)
                setLabelData(data)
                var _learnq = window._learnq || []
                retryLearnQ(() => {
                  _learnq.push([
                    'track',
                    'Added Personalisation',
                    {
                      ...data,
                      url: window.location.href,
                      sku: selectedVariant?.SKU,
                    },
                  ])
                }, 3000)
              }}
              handleClose={() => setPersonaliseOpen(false)}
              initialValues={labelData}
              productData={personaliseData}
              timeframe={storeLocale === 'en-GB' ? '7' : storeLocale === 'en' ? '4-6' : '3-5'}
            />
          </div>
        )}
      </div>
      <LandingContainer>
        <GallerySection
          images={images}
          thumbnails={thumbnails}
          selectedColor={selectedColor}
          pdpRibbon={data.strapiShared?.GalleryRibbon}
          product_categories={product?.product_categories}
          discount={discount}
          defaultImage={selectedVariant?.onChangeImageIndex ? selectedVariant?.onChangeImageIndex : 0}
          disablePersonalisation={data.strapiShared?.disablePersonalisation}
          disableEmbroidery={data.strapiShared?.disableEmbroidery}
          locale={storeLocale}
          discountPromoOn={discountPromoOn}
          productId={productId}
          showBuildSet={['Carry_On', 'Checked', 'Plus'].includes(product?.BundleType)}
          hideRibbon={selectedSKU === 'AOC-PROV2-COPB28-CRM'}
        />
        <SelctorSection
          inViewRef={inViewRef}
          discountPromoOn={discountPromoOn}
          reviewData={reviewData}
          isInView={isInView}
          upsell={product?.Upsell}
          comparison={product.Comparison}
          returnAddToCart={returnAddToCart}
          name={product.Title}
          subHeading={product.SubHeadingText}
          price={price}
          outline={product.Description}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          handleAddToCart={handleAddToCart}
          reviewId={productId}
          tolstoyId={tolstoyId}
          variants={allVariants}
          expandSections={product.ExpandSections}
          hasPersonlisation={product.Personalisation[0] != undefined && selectedVariant.personaliseInfo}
          personalisationCost={product.Personalisation[0]?.PersonalisationCost}
          freePersonalisation={FreePersonalisation ? FreePersonalisation : product.Personalisation[0]?.FreePersonalisation}
          freeSuitcasePersonalisation={FreeSuitcasePersonalisation}
          discount={discount}
          shortName={product.ShortName}
          personalised={personalised}
          petPersonalised={petPersonalised}
          labelData={labelData}
          petLabelData={petLabelData}
          setPersonaliseOpen={setPersonaliseOpen}
          setPetPersonalisationOpen={setPetPersonalisationOpen}
          selectedVariant={selectedVariant}
          noSet={noSet}
          setCollectionOpen={setCollectionOpen}
          signup_id={product.ProductSignUpId ? product.ProductSignUpId : OosSignupID}
          useDropdown={product.useDropdown}
          AirlineReq={product.AirlineReq}
          product_categories={product.product_categories}
          dropdownData={product.Dropdown}
          selectedDropdownItem={selectedDropdownItem}
          setSelectedDropdownItem={setSelectedDropdownItem}
          aboveColorSelector={product.ToggleItems}
          useToggleSelector={product.UseToggleSelector}
          url={product.handle}
          PetPersonalisation={PetPersonalisation}
          hideBundlePricing={hideBundlePricing || false}
          disablePersonalisation={disablePersonalisation || false}
          disableEmbroidery={disableEmbroidery || false}
          isBag={isBag || false}
          productId={product?.shopifyInfo?.shopifyId?.replace('gid://shopify/Product/', '')}
          stickySelector={product["GalleryType"] ===  "Scroll"}
        />
      </LandingContainer>
      {product.Panels && <PanelRenderer blocks={product.Panels} locale={pageContext.locale} />}
      {productId && reviewData.aggregateRating > 0  && <Reviews productId={productId} />}
    </>
  )
}

// Look into moving from variants to Variant instead
export const pageQuery = graphql`
  query ($handle: String, $locale: String, $additionalStrapiProducts: [String]) {
    stock(locale: { eq: $locale }) {
      skus
    }
    strapiShared(locale: { eq: $locale }) {
      hideBundlePricing
      disablePersonalisation
      disableEmbroidery
      GalleryRibbon {
        RibbonText
        RibbonColour
        RibbonTextColour
        productPageOn
        NonPersRibbon
      }
      locale
      OosSignupID
      FreePersonalisation
      FreeSuitcasePersonalisation
      PetPersonalisation
      discountPromoOn
    }
    additionalStrapiProducts: allStrapiProduct(filter: { id: { in: $additionalStrapiProducts } }) {
      nodes {
        Category
        SubCategory
        Range

        id
        strapiId
        handle
        product_categories {
          CategoryName
        }
        Variants {
          SKU
          Colour
          ColourName
          limited
          seperationText
          onChangeImageIndex
          SignUpID
          images {
            mime
            alternativeText
            name
            file {
              childImageSharp {
                gatsbyImageData(width: 1000, placeholder: NONE, quality: 80)
                gatsbyImageDataMobile: gatsbyImageData(quality: 70, placeholder: NONE, width: 550)
              }
              publicURL
            }
            url
          }
          ShopTileImage {
            ...Image
          }
          Edition

          thumbnails: images {
            mime
            alternativeText
            name
            file {
              childImageSharp {
                gatsbyImageData(width: 48, placeholder: NONE)
              }
              publicURL
            }
            url
          }
          personaliseInfo
        }
      }
    }
    strapiProduct(handle: { eq: $handle }, locale: { eq: $locale }) {
      id
      Category
      SubCategory
      Range
      GalleryType
      strapiId
      locale
      Title
      BundleType
      handle
      useDropdown
      ProductSignUpId
      Discount
      hideSetModule
      ShortName
      BundleRange
      BundleType
      SubHeadingText
      Dropdown {
        DropdownItem
        to
      }
      Comparison {
        Collection
        link
      }
      Upsell {
        Discount
        Heading
        Product {
          product_categories {
            CategoryName
          }
          shopifyInfo {
            ... on AUShopifyProduct {
              shopifyId
            }
            ... on USShopifyProduct {
              shopifyId
            }
            ... on CAShopifyProduct {
              shopifyId
            }
            ... on NZShopifyProduct {
              shopifyId
            }
            ... on UKShopifyProduct {
              shopifyId
            }
          }
          Variants {
            Colour
            TwoWide
            ColourName
            SKU
            SignUpID
            ShopTileImage {
              ...Image
            }
            Edition
            metaShopifyInfo {
              ... on AUShopifyProductVariant {
                product {
                  shopifyId
                }
                shopifyId
              }
            }
            shopifyInfo {
              ... on AUShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on USShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on CAShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on NZShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on UKShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
            }
            shopifyInfoPers {
              ... on UKShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on NZShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on USShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on CAShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on AUShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
            }
            personaliseInfo
          }
          handle
          Title
        }
        Subheading
      }
      Personalisation {
        PersonalisationCost
        FreePersonalisation
      }
      product_categories {
        CategoryName
      }
      shopifyInfo {
        ... on AUShopifyProduct {
          shopifyId
          storefrontId
          reviewData {
                aggregateRating
                shopifyId
                __typename
                reviewCount
              }

        }
        ... on USShopifyProduct {
          shopifyId
          storefrontId
          reviewData {
                aggregateRating
                shopifyId
                __typename
                reviewCount
              }

        }
        ... on CAShopifyProduct {
          shopifyId
          storefrontId
          reviewData {
                aggregateRating
                shopifyId
                __typename
                reviewCount
              }
        }
        ... on UKShopifyProduct {
          shopifyId
          storefrontId
          reviewData {
                aggregateRating
                shopifyId
                __typename
                reviewCount
              }

        }
        ... on NZShopifyProduct {
          shopifyId
          storefrontId
          reviewData {
                aggregateRating
                shopifyId
                __typename
                reviewCount
              }

        }
      }
      Variants {
        SignUpID
        metaShopifyInfo {
          ... on AUShopifyProductVariant {
            product {
              shopifyId
            }
            shopifyId
          }
        }
        shopifyInfo {
          ... on AUShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on USShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on CAShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on UKShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on NZShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
        }
        shopifyInfoPers {
          ... on AUShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on USShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on CAShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on UKShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
          ... on NZShopifyProductVariant {
            shopifyId
            sku
            title
            price
            image {
              gatsbyImageData(width: 200)
            }
          }
        }
        SKU
        Colour
        ColourName
        onChangeImageIndex
        limited
        images {
          mime
          alternativeText
          name
          file {
            childImageSharp {
              gatsbyImageData(width: 1000, placeholder: NONE, quality: 80)
              gatsbyImageDataMobile: gatsbyImageData(quality: 70, placeholder: NONE, width: 550)
            }
            publicURL
          }
          url
        }
        ShopTileImage {
          ...Image
        }
        Edition

        thumbnails: images {
          mime
          alternativeText
          name
          file {
            childImageSharp {
              gatsbyImageData(width: 48, placeholder: NONE)
            }
            publicURL
          }
          url
        }
        personaliseInfo
      }
      Description
      ExpandSections {
        Title
        Body
      }
      Panels {
        ...RecursivePanels
      }
      ToggleItems {
        ProductTitle
        to
        FeatureItems {
          FeatureDescription
          FeatureImage {
            ...Image
          }
        }
      }
      UseToggleSelector
      seo {
        canonicalURL
        metaDescription
        metaTitle
        keywords
        doNotIndex
        metaImage {
          file {
            childImageSharp {
              gatsbyImageData(width: 1200, placeholder: NONE, formats: [JPG])
            }
          }
        }
        metaSocial {
          image {
            file {
              childImageSharp {
                fixed(width: 1200) {
                  srcWebp
                }
              }
            }
          }
          socialNetwork
          title
          description
        }
      }
      AirlineReq {
        SizeCompatibility {
          AirlineName
          Compatible
        }
      }
    }
  }
`
export default ArticlePage
